
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/partnerships",
      function () {
        return require("private-next-pages/company/partnerships.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company/partnerships"])
      });
    }
  